const getAllTags = (templates) => {
  const tags = templates.map(({ tags }) => tags);
  const flattened = [].concat(...tags);

  return Array.from(new Set(flattened));
};

const getTemplatesIdsByTag = (templates, tag) => {
  const filtered = templates.filter(({ tags }) => tags && tags.includes(tag));

  return filtered.map(({ template_id }) => template_id);
};

module.exports = {
  getTemplatesIdsByTag,
  getAllTags,
};



// WEBPACK FOOTER //
// ./shared/lib/templates.js